<template>
  <div class="container-fluid mt-2">
    <h2>Daten-Tabellen</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" id="search" @keyup="updateSearch()" v-model="search" type="text"/>
      </div>
      <button id="new" @click="addTable()" class="btn btn-primary">Hinzuf&uuml;gen</button>
    </div>
    <b-table no-local-sorting @sort-changed="updateSort" @row-clicked="open" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(action)="data">
        <button @click="deleteTable(data.item)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import datamap from '@/modules/datamap.js'

export default {
  name: 'DataTablesView',
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'action', label: 'Aktion' }
      ],
      start: 0,
      count: 20,
      rows: [],
      search: "",
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    nextPage() {
      this.start += this.count;
      this.fetchData();
    },
    prevPage() {
      if (this.start > 0) {
        this.start -= this.count;
        this.fetchData();
      }
    },
    fetchData: function() {
      var self = this;
      datamap.listtables(this,this.start,this.count,'name',this.search,function(data) {
        self.rows = data;
      });
    },
    open: function(row,e) {
      console.log('open');
      console.log(JSON.stringify(row));
      console.log(e);
      router.push({name:'DataTableEditor',params:{ name:row.name, sys: false }})
    },
    deleteTable: function(row) {
      console.log('delete1');
      console.log(row);
      if (confirm('Möchten Sie die Tabelle ' + row.name + ' wirklich löschen?')) {
        var self = this;
        datamap.deletetable(this,row.name,function() {
          self.$bvToast.toast('Tabelle wurde gelöscht',{title: 'Datamapping',variant:'success'});
          self.fetchData();
        })
      }
    },
    updateSort: function() {
    },
    searchUpdate() {
    },
    updateSearch: function() {
      console.log(this.search);
      if (this.search.length == 0 || this.search.length > 2)
        this.fetchData();
    },
    addTable: function() {
      router.push({name:'DataTableEditor'});
    }
  }
}
</script>
